import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import StaffForm from "../components/StaffForm";
import OpponentForm from "../components/OpponentForm";

export default function OpponentEdit({ opponent }: { opponent: any }) {

    const saveOpponent = (form: any) => {
        const requester = new Requester();

        const data = new FormData();

        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        requester.post(requester.getUrl(`api/opponents/${opponent.id}`), data).then((response) => {
            router.visit(`/admin/opponents`);
        }).catch((error) => {
            alert("Error editing opponent: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Opponent" />
            <ContentWrapper>
                <OpponentForm onSubmit={saveOpponent} opponent={opponent} />
            </ContentWrapper>
        </App >
    )
}